import {createI18n} from 'vue-i18n';

const FALLBACK_LOCALE = 'en';

const normalizeLocale = (value) => {
  if (typeof value !== 'string' || !value.trim()) {
    return FALLBACK_LOCALE;
  }

  return value.replace('_', '-');
};

const loadTranslations = async () => {
  const htmlLocale = normalizeLocale(document.documentElement?.lang);
  const translationsUrl = window.Craft?.translationsUrl || `/${htmlLocale}/translations.json`;

  try {
    const response = await fetch(translationsUrl, {
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      console.error(`Failed to load translations (${response.status})`);
      return {
        locale: htmlLocale,
        messages: {},
      };
    }

    const payload = await response.json();
    const locale = normalizeLocale(payload?.locale || htmlLocale);
    const messages = (payload && typeof payload === 'object' && payload.messages && typeof payload.messages === 'object')
      ? payload.messages
      : {};

    return { locale, messages };
  } catch (error) {
    console.error('Unable to fetch translations.json.', error);

    return {
      locale: htmlLocale,
      messages: {},
    };
  }
};

export const createAppI18n = async () => {
  const { locale, messages } = await loadTranslations();

  return createI18n({
    legacy: false,
    locale,
    fallbackLocale: FALLBACK_LOCALE,
    messages: {
      [locale]: messages,
    },
  });
};
